import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const CTASection = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Cauți un Detectiv Bacau de Încredere?
        </h2>
        <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto">
          Consultația inițială cu detectivii particulari Bacau este gratuită și confidențială. 
          Sunați-ne sau completați formularul pentru a discuta cazul dumneavoastră cu un detectiv privat Bacau.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-white text-slate-900 hover:bg-slate-100 font-semibold px-10 py-6 text-base"
          >
            Solicită Consultație
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <a href={`tel:${companyInfo.phone}`}>
            <Button
              variant="outline"
              size="lg"
              className="border-slate-600 text-white hover:bg-slate-800 px-10 py-6 text-base w-full sm:w-auto"
            >
              <Phone className="w-5 h-5 mr-2" />
              {companyInfo.phone}
            </Button>
          </a>
        </div>

        <p className="mt-8 text-slate-500 text-sm">
          Detectivi Bacau • Program NON-STOP 24/7 • Răspuns în maxim 2 ore
        </p>
      </div>
    </section>
  );
};

export default CTASection;
